import { previewDashboardSearchSchema } from '@/config/commonSearch';
import { z } from 'zod';

export const reportsSearchSchema = previewDashboardSearchSchema.extend({});

export type ReportsSearchSchema = z.infer<typeof reportsSearchSchema>;

export { Reports } from './Reports';
